import { HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { FileTextIcon } from 'lucide-react';

export function PdfLinkComponent({ href, title }) {
  const handleClick = () => {
    window.open(href, '_blank');
  };

  return (
    <HStack
      maxW="xs"
      p="2"
      gap="16px"
      borderWidth="1px"
      borderColor="border.default"
      rounded="8px"
      justify="start"
      align="center"
      cursor="pointer"
      onClick={handleClick}
      role="group"
      _hover={{
        shadow: 'xs',
        bg: 'bg.subtle',
      }}
    >
      <VStack gap="0" align="center" justify="center">
        <Icon as={FileTextIcon} boxSize="10" _groupHover={{ color: 'brand.500' }} />
      </VStack>
      <VStack gap="0" align="start" justify="center">
        <Text fontWeight="medium" fontSize="md" _groupHover={{ color: 'brand.500' }}>
          Download File
        </Text>
        <Text fontSize="sm" color="fg.muted" _groupHover={{ color: 'fg.emphasis' }}>
          {title}
        </Text>
      </VStack>
    </HStack>
  );
}

export default PdfLinkComponent;
